"use client"
import { ArrowRight } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    type CarouselApi,
} from "@/components/ui/carousel"

const data = [
    {
        id: "1",
        image: "/assets/images/services/Esngineer.jpg",
        href: "https://skillsewa.info/booking?title=Engineer Consultation",
        name: "Engineer Consultation",
        description: "Fast and reliable engineer consulting server at your finger tips."
    },
    {
        id: "2",
        image: "/assets/images/services/Construction.jpg",
        href: "https://skillsewa.info/booking?title=Construction",
        name: "Construction",
        description: "High-quality construction, committed to delivering projects within budget"
    },
    {
        id: "3",
        image: "/assets/images/services/engineer/engineerTwo.jpeg",
        href: "https://skillsewa.info/booking?title=Renovation",
        name: "Renovation",
        description: "Fast and reliable engineer consulting server at your finger tips."
    }
]
const MostBookedMobil = () => {
    const [api, setApi] = React.useState<CarouselApi>()
    const [current, setCurrent] = React.useState(0)
    const [count, setCount] = React.useState(0)
    React.useEffect(() => {
        if (!api) {
            return
        }
        setCount(api.scrollSnapList().length)
        setCurrent(api.selectedScrollSnap() + 1)
        api.on("select", () => {
            setCurrent(api.selectedScrollSnap() + 1)
        })
    }, [api])
    return (
        <section id="services" className=' sm:hidden'>
            <div className='flex flex-col gap-10'>
                <h2 className='text-s-header'>MOST BOOKED ONES</h2>
                <div className='flex gap-10 pr-4'>
                    <div className="max-w-sm">
                        <Carousel setApi={setApi} className="w-full max-w-sm">
                            <CarouselContent>

                                {data.map((service, index) => (
                                    <CarouselItem key={index}>
                                        <aside className='w-full border p-4 flex flex-col gap-4 rounded-lg'>
                                            <Image
                                                src={service.image}
                                                alt={service.name}
                                                height={1280}
                                                width={488}
                                                className="rounded-lg object-fit h-[19rem]"
                                            />
                                            <div className='flex flex-col gap-2'>
                                                <h3 className='text-2xl font-medium'>{service.name}</h3>
                                                <p className='text-sm text-muted-foreground'>{service.description}</p>
                                                <footer className='flex justify-between itmes-center mt-1'>
                                                    <Link href={`https://skillsewa.info/booking?title=Engineer Consultation`} className='flex gap-2 items-center'>
                                                        <p className='text-sm font-medium'>Book now</p>
                                                        <ArrowRight className='h-4 w-4' />
                                                    </Link>
                                                    <div className='bg-green-500 p-1 px-4 rounded-full'>
                                                        <span className='text-sm text-zinc-50 m-0 p-0'>Available</span>
                                                    </div>
                                                </footer>
                                            </div>
                                        </aside>
                                    </CarouselItem>
                                ))}
                            </CarouselContent>
                        </Carousel>
                        <div className="text-muted-foreground py-2 text-center text-sm">
                            Service {current} of {count}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MostBookedMobil